import DeadlineDateFilter from 'components/brokers/workflows/DeadlineDateFilter'

import { type SingleSelectedValueFilter } from '../types'

const CoverageStartDateBeforeFilter = (props: SingleSelectedValueFilter) => {
  return (
    <DeadlineDateFilter {...props} rangeType='Coverage start before' />
  )
}

export default CoverageStartDateBeforeFilter
